module.exports = __webpack_public_path__ + "static/media/Myprofile.4ef20445.jpg";